import { render, staticRenderFns } from "./BulletEdit.vue?vue&type=template&id=4d95f72f&scoped=true"
import script from "./BulletEdit.vue?vue&type=script&lang=js"
export * from "./BulletEdit.vue?vue&type=script&lang=js"
import style0 from "./BulletEdit.vue?vue&type=style&index=0&id=4d95f72f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95f72f",
  null
  
)

export default component.exports